const parseGasPrice = (price) => {
  if (!price || typeof price !== "string") {
    return {
      dollars: null,
      fraction: null
    };
  }
  const cleanPrice = price.trim().replace(/[$\s,]/g, "");
  const isValidPrice = (str) => {
    const decimalCount = (str.match(/\./g) || []).length;
    if (decimalCount > 1) return false;
    return /^[\d.]+$/.test(str);
  };
  if (!cleanPrice || !isValidPrice(cleanPrice)) {
    return {
      dollars: null,
      fraction: null
    };
  }
  const numericPrice = parseFloat(cleanPrice);
  if (isNaN(numericPrice) || numericPrice < 0) {
    return {
      dollars: null,
      fraction: null
    };
  }
  const formatted = numericPrice.toFixed(3);
  const [dollarsPart, decimalPart] = formatted.split(".");
  const dollars = parseFloat(
    `${dollarsPart}.${decimalPart == null ? void 0 : decimalPart.slice(0, 2)}`
  ).toFixed(2);
  const fraction = (decimalPart == null ? void 0 : decimalPart.slice(2, 3)) || "0";
  return {
    dollars,
    fraction
  };
};
export {
  parseGasPrice
};
